import { queryOptions } from '@tanstack/react-query'
import { Pagination } from '@thinknimble/tn-models'
import { notificationApi } from './api'
import { NotificationFilter } from './models'

export const notificationQueries = {
  all: () => ['notifications'],
  list: ({
    filters,
    pagination,
    paginationCallback,
  }: {
    filters?: Partial<NotificationFilter>
    pagination?: Pagination
    paginationCallback?: (pagination: Pagination) => void
  }) => {
    return queryOptions({
      queryKey: [...notificationQueries.all(), { filters, pagination }],
      queryFn: async () => {
        const res = await notificationApi.list({
          filters,
          pagination,
        })
        const serverPagination = new Pagination({ ...res, totalCount: res.count })
        paginationCallback?.(serverPagination)
        return res
      },
      enabled: true,
    })
  },
  unreadCount: () => {
    return queryOptions({
      queryKey: [...notificationQueries.all(), 'unread-count'],
      queryFn: () => notificationApi.csc.unreadCount(),
    })
  },
}
